import React, { Component } from "react";

export default class LeaveBalanceCalculationStatistics extends Component {
  get employeesCount() {
    return new Set(
      this.props.data.map((employee) => {
        return employee.user_id;
      })
    ).size;
  }

  get branchesCount() {
    return new Set(
      this.props.data.map((employee) => {
        return employee.branch_id;
      })
    ).size;
  }

  get departmentsCount() {
    return new Set(
      this.props.data.map((employee) => {
        return employee.departments_id;
      })
    ).size;
  }

  render() {
    if (this.props.data.length === 0) return null;

    return (
      <div className="row" style={styles.sectionMargin}>
        <span style={styles.blueTextHeading}>
          {this.employeesCount} Employees
        </span>
        <span style={styles.blueTextNormal}>{this.branchesCount} Branches</span>
        <span style={styles.blueTextNormal}>
          {this.departmentsCount} Departments
        </span>
      </div>
    );
  }
}

const styles = {
  sectionMargin: {
    margin: "25px 10px",
    display: "flex",
    alignItems: "center",
  },
  blueTextHeading: {
    color: "#27568a",
    fontSize: 20,
    fontWeight: "bold",
    marginRight: "50px",
  },
  blueTextNormal: {
    color: "#27568a",
    fontSize: 12,
    marginRight: "50px",
  },
};
